import qs from 'qs';
// Returns a slug from the category name.
// Spaces are replaced by "+" to make
// the URL easier to read and other
// characters are encoded.
function getCategorySlug(name) {
  return name.split(' ').map(encodeURIComponent).join('+');
}

// Returns a name from the category slug.
// The "+" are replaced by spaces and other
// characters are decoded.
function getCategoryName(slug) {
  return slug.split('+').map(decodeURIComponent).join(' ');
}

export const createURL = (state) => {
  const isDefaultRoute =
    !state.query &&
    state.page === 1 &&
    state.refinementList &&
    state.refinementList.brand.length === 0 &&
    state.menu &&
    !state.menu.categories;

  if (isDefaultRoute) {
    return '';
  }

  const categoryPath = state.menu.categories ? `${getCategorySlug(state.menu.categories)}/` : '';
  const queryParameters = {};

  if (state.query) {
    queryParameters.query = encodeURIComponent(state.query);
  }
  if (state.page !== 1) {
    queryParameters.page = state.page;
  }
  if (state.refinementList.brand) {
    queryParameters.brands = state.refinementList.brand.map(encodeURIComponent);
  }

  const queryString = qs.stringify(queryParameters, {
    addQueryPrefix: true,
    arrayFormat: 'repeat',
  });

  return `/search/${categoryPath}${queryString}`;
};

const searchStateToUrl = (searchState) => (searchState ? createURL(searchState) : '');

export const urlToSearchState = (location) => {
  let params = new URLSearchParams(location.search);
  // const pathnameMatches = location.pathname.match(/search\/(.*?)\/?$/);
  // console.log(pathnameMatches);
  // const category = getCategoryName((pathnameMatches && pathnameMatches[1]) || '');
  // const { query = '', page = 1, brands = [] } = qs.parse(location.search.slice(1));
  // // `qs` does not return an array when there's a single value.
  // const allBrands = Array.isArray(brands) ? brands : [brands].filter(Boolean);

  let refinementList = {};
  params.has('capacity') && (refinementList['named_tags.Capacity'] = params.getAll('capacity'));
  params.has('product_type') && (refinementList['product_type'] = params.getAll('product_type'));
  // console.log(refinementList);

  return {
    // query: decodeURIComponent(query),
    // page,
    // menu: {
    //   categories: decodeURIComponent(category),
    // },
    refinementList,
    // refinementList: {
    //   // "name_tags.Capacity": allBrands.map(decodeURIComponent),
    //   // 'name_tags.Capacity': decodeURIComponent(capacity),
    // },
  };
};
